import { Component } from "kernelplay-js";
import * as PIXI from "pixi.js";

// WebGLBoxRender2D.js
export class PixiBoxRenderComponent extends Component {
  constructor({ color, zIndex = 0 }) {
    super();

    this.width = 50;
    this.height = 50;
    this.color = color || "#ff0000";
    this.zIndex = zIndex; // 🔥 ADD THIS

    this.object = new PIXI.Graphics().rect(0, 0, this.width, this.height);
    this.object.pivot.set(this.width / 2, this.height / 2);
    
    // 🔥 Cache for spatial grid
    this._cachedBounds = { x: 0, y: 0, width: 0, height: 0 };
  }

  onStart() {
    this.object.entity = this.entity;
    this.object.fill(this.color);
    this.object.zIndex = this.zIndex; // 🔥 PixiJS native zIndex
    this.entity.scene.game.renderer.app.stage.addChild(this.object);
    
    // 🔥 Enable sorting
    this.entity.scene.game.renderer.app.stage.sortableChildren = true;
  }
  
  // 🔥 ADD THIS for spatial grid
  getBounds() {
    const t = this.entity.getComponent("transform");
    
    const w = this.width * t.scale.x;
    const h = this.height * t.scale.y;
    
    this._cachedBounds.x = t.position.x - w * 0.5;
    this._cachedBounds.y = t.position.y - h * 0.5;
    this._cachedBounds.width = w;
    this._cachedBounds.height = h;
    
    return this._cachedBounds;
  }

  onDestroy() {
    this.object.removeFromParent();
    this.object.destroy();
  }
}
